import { LicenceDetailedDto } from "../../types/dto";
import { get, isMockMode, simulateDelay } from "../api";

// TODO ANYS
export const setLicencesState = (licences: any) =>
	licences.map(setSingleLicenceState);

export const setSingleLicenceState = (licence: any) => {
	let state = "Active";
	if (!licence) {
		state = "Error";
	} else if (licence.isSubEnabled === false) {
		state = "Subscription disabled";
	} else if (
		(licence.finalExpirationUtc &&
			new Date(licence.finalExpirationUtc) < new Date()) ||
		(licence.licenceExpirationUtc &&
			new Date(licence.licenceExpirationUtc) < new Date()) ||
		(licence.subExpirationUtc &&
			new Date(licence.subExpirationUtc) < new Date())
	) {
		state = "Expired";
	} else if (licence.isRevoked) {
		state = "Revoked";
	} else if (!licence.lastActivatedUtc) {
		state = "Not activated";
	}

	return { ...licence, state };
};

const setLicenceStateResponse = (response: any) => {
	response.licences = setLicencesState(response.licences);

	return response;
};

export interface GetForUserReturn {
	licences: Array<LicenceDetailedDto>;
}

export const getForUser = () => {
	if (isMockMode()) {
		const testData = {
			licences: [
				{
					product: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					isRevoked: false,
					lastActivatedUtc: null,
					cooldownUntilUtc: null,
					lastUsedUtc: null,
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					finalExpirationUtc: "2022-04-28T14:00:00",
					activeMachine: null,
					machineHash: null,
					subscriberOrg: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					subscriptionManagers: [
						{
							email: "test.mctestie@mgaol.abc",
							firstName: null,
							lastName: null,
						},
						{
							email: "test.mctestie@mgaol.abc",
							firstName: null,
							lastName: null,
						},
						{
							email: "test.mctestie@mgaol.abc",
							firstName: "Test",
							lastName: "McTestie",
						},
						{
							email: "test.mctestie@mgaol.abc",
							firstName: "Test",
							lastName: "McTestie",
						},
						{
							email: "test.mctestie@mgaol.abc",
							firstName: null,
							lastName: null,
						},
						{
							email: "test.mctestie@mgaol.abc",
							firstName: null,
							lastName: null,
						},
					],
				},
			],
		};

		return simulateDelay(50, () =>
			setLicenceStateResponse(testData)
		) as Promise<GetForUserReturn>;
	}

	return get(`Licences/GetForUser`).then(
		setLicenceStateResponse
	) as Promise<GetForUserReturn>;
};
